import React from 'react';
import { useDispatch } from 'react-redux';
import { imageSettingsChangeImageType } from '../state/controller';
import { PanelSubSectionComponent } from '../../../core/components/panel/PanelComponent';

const CustomImageContainer = () => {
  const dispatch = useDispatch();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const customImageNode = document.getElementById('customImage');

        customImageNode && customImageNode.remove();

        const image = document.createElement('img');

        image.style.display = 'none';
        image.id = 'customImage';

        if (reader.result) {
          image.src = reader.result as string;
        }

        document.body.append(image);

        dispatch(imageSettingsChangeImageType(''));
        dispatch(imageSettingsChangeImageType('custom'));
      };

      reader.readAsDataURL(e.target.files[0]);
    }
  };

  return (
        <PanelSubSectionComponent>
            <p>Загрузите свой фон</p>
            <input type="file" onChange={onChange} />
        </PanelSubSectionComponent>
  );
};

export default CustomImageContainer;
